import type {AlignedPlacement, Placement} from '@floating-ui/react';

export type XAlign = 'left' | 'right';
export type YAlign = 'top' | 'bottom';

/**
 * Maps our `preferX`/`preferY` props onto a Floating UI placement. `preferY`
 * picks the side the floating element sits on; `preferX` aligns it along that
 * side's edge, which Floating UI spells `-start`/`-end`.
 *
 * Both preferences are required. Popper's `auto-*` placements have no Floating
 * UI equivalent — `flip()` and `shift()` middleware do that job — so callers
 * pass their own defaults rather than relying on an `auto` fallback.
 */
export function placementFromPreferences(
  preferX: XAlign,
  preferY: YAlign,
): AlignedPlacement {
  return `${preferY}-${preferX === 'left' ? 'start' : 'end'}`;
}

/**
 * The inverse, read off the placement Floating UI actually resolved — `flip()`
 * may have moved the floating element to the opposite side of the anchor.
 * Components use this to aim transform origins, corner radii, and tooltip tails
 * back at the anchor.
 */
export function alignmentFromPlacement(placement: Placement): {
  xAlign: XAlign;
  yAlign: YAlign;
} {
  return {
    xAlign: placement.includes('start') ? 'left' : 'right',
    yAlign: placement.includes('bottom') ? 'bottom' : 'top',
  };
}
